enum ClaimType {
  Claim = 'Claim',
  Dispute = 'Dispute',
  Application = 'Application',
}
export default ClaimType;
